import Code from 'components/Code';

export const contentBlocks = {
  Code,
};